import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cpassarg(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>Passing arguments to a Function in C Tutorial For Beginners</title>
 <meta name="description" content="passing function as argument in c tutorial for beginners.passing function as argument in CAn argument may be a variable as a constant value that is used in the () of function.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c passing operator,c operator,operator in c language,passing operator" />
 <link rel="canonical" href="https://www.codeexampler.com/c-passing-argument" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Passing arguments to a Function in C</h1>
    <div className="first">
        <a href="/c-user-defined-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">Passing arguments to a function in C: An argument may be a variable as a constant value used in the () of function.
</p>



<h2 className='headings'>Q-Passing function as an arguement in C example?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"100vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-10">stdio.h</span>
            <span className="qwerty-4">&#62; </span>
        {"\n"}
            <span className="qwerty-3">void </span>
            <span className="qwerty-2">arguement</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-5">n</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-5">//int n is a formal arguement</span>
        {"\n"}
            <span className="qwerty-4" >&#123; </span>
        {"\n"}
        <span className="qwerty-8"> printf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-10">my no is</span>
            <span className="qwerty-3"> %d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-5">n</span>
            <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-4">&#125;</span>
        {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-2">main</span>
            <span className="qwerty-4"> ()</span>
        {"\n"}
            <span className="qwerty-4" >&#123; </span>
        {"\n"}
        <span className="qwerty-3"> int </span>
            <span className="qwerty-5">n</span>
            <span className="qwerty-4">;</span>
        {"\n"}
            <span className="qwerty-8"> scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1">&amp;</span>
            <span className="qwerty-5">n</span>
            <span className="qwerty-4">);</span>
        {"\n"}
          <span className="qwerty-2"> arguement</span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-5">n</span>
            <span className="qwerty-4">);</span>
            <span className="qwerty-5">//calling function</span> 
          {"\n"}
            <span className="qwerty-8"> printf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-10">Enter a no</span>
            <span className="qwerty-4">");</span>
        {"\n"}
        {"\n"}
            <span className="qwerty-7"> return</span>
            <span className="qwerty-3"> 0</span>
            <span className="qwerty-4">; </span>
        {"\n"}
            <span className="qwerty-4">&#125;</span>
    </code>
    </pre>
    </div>          
    <h4 className='headings'>Output :</h4>
     <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
            <code >
                {"\n"}
                    <span className="qwerty-5">This is a function program</span>
                {"\n"}
                    <span className="qwerty-3">hello function</span>
                {"\n"}
                    <span className="qwerty-5">hello is a function</span>
                {"\n"}{"\n"}
                </code>
            </pre>
            </div>  




<h2 className='headings'>Q-Write a program to check a no is even or odd by using a passing arguement?</h2>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
        <pre style={{maxHeight:"100vh"}}>
            <code >
              {"\n"}
                  <span className="qwerty-7">#include </span>
                  <span className="qwerty-4">&#60;</span>
                  <span className="qwerty-10">stdio.h</span>
                  <span className="qwerty-4">&#62; </span>
              {"\n"}
                  <span className="qwerty-3">void </span>
                  <span className="qwerty-2">check</span>
                  <span className="qwerty-4"> (</span>
                  <span className="qwerty-3">int</span>
                  <span className="qwerty-5"> i</span>
                  <span className="qwerty-4">)</span>
                  <span className="qwerty-5"> //</span>
                  <span className="qwerty"> (int i)</span>
                  <span className="qwerty-5"> is a formal arguement</span>
              {"\n"}
                  <span className="qwerty-4" >&#123; </span>
              {"\n"}
               <span className="qwerty-6"> if </span>
               <span className="qwerty-4">(</span>
               <span className="qwerty-5">a</span>
               <span className="qwerty">%</span>
               <span className="qwerty-1">2</span>
               <span className="qwerty"> == </span>
               <span className="qwerty-1">0</span>
               <span className="qwerty-4">) </span>
           {"\n"}
               <span className="qwerty-4" > &#123; </span>
           {"\n"}          
           <span className="qwerty-8">  printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-10"> even no </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" > &#125;</span>       
           {"\n"}
               <span className="qwerty-6"> else </span>
                           {"\n"}
               <span className="qwerty-4" > &#123; </span>
           {"\n"}       
           <span className="qwerty-8">  printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2"> odd no </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" > &#125;</span>       
           {"\n"}     
              <span className="qwerty-4">&#125;</span>
              {"\n"}
                  <span className="qwerty-3">int </span>
                  <span className="qwerty-2">main</span>
                  <span className="qwerty-4"> ()</span>
              {"\n"}
                  <span className="qwerty-4" >&#123; </span>
              {"\n"}
              <span className="qwerty-3"> int </span>
                  <span className="qwerty-5">i</span>
                  <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-8"> printf</span>
                  <span className="qwerty-4">("</span>
                  <span className="qwerty-10">Enter a no</span>
                  <span className="qwerty-4">");</span>
              {"\n"}
                  <span className="qwerty-6"> scanf</span>
                  <span className="qwerty-4">("</span>
                  <span className="qwerty-3">%d</span>
                  <span className="qwerty-4">",</span>
                  <span className="qwerty-1">&amp;</span>
                  <span className="qwerty-5">i</span>
                  <span className="qwerty-4">);</span>
              {"\n"}
                <span className="qwerty-2"> check</span>
                  <span className="qwerty-4">(</span>
                  <span className="qwerty-3">int </span>
                  <span className="qwerty-5">n</span>
                  <span className="qwerty-4">);</span>
                  <span className="qwerty-5">//</span> 
                  <span className="qwerty">i</span> 
                  <span className="qwerty-5"> is a actual arguement</span> 
                {"\n"}              
                  <span className="qwerty-7"> return</span>
                  <span className="qwerty-3"> 0</span>
                  <span className="qwerty-4">; </span>
              {"\n"}
                  <span className="qwerty-4">&#125;</span>
              {"\n"}
              {"\n"}
          </code>
          </pre>
          </div>          
          <h4 className='headings'>Output :</h4>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
         <pre style={{maxHeight:"100vh"}}>
               <code >                  
               {"\n"}      
                 <span className="qwerty-8">Enter a value</span>                   
                 <span className="qwerty-1"> 46</span>                   
                 {"\n"}                           
                 <span className="qwerty-3">even no</span>                   
                 {"\n"}   {"\n"} 
                 </code>
                 </pre>
                 </div> 




<h2 className='headings'>Q-Write a program check greater no by using function?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"100vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-10">stdio.h</span>
            <span className="qwerty-4">&#62; </span>
        {"\n"}
            <span className="qwerty-3">void </span>
            <span className="qwerty-2">maximum</span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">int</span>
            <span className="qwerty-5"> a</span>
            <span className="qwerty-4">,</span>
            <span className="qwerty-3"> int</span>
            <span className="qwerty-5"> b</span>
            <span className="qwerty-4">)</span>
        {"\n"}
            <span className="qwerty-4" >&#123; </span>
        {"\n"}
        <span className="qwerty-6"> if </span>
               <span className="qwerty-4">(</span>
               <span className="qwerty-5">a</span>
               <span className="qwerty">&#62;</span>
               <span className="qwerty-5">b</span>
               <span className="qwerty-4">) </span>
           {"\n"}
               <span className="qwerty-4" > &#123; </span>
           {"\n"}          
           <span className="qwerty-8">  printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-10">maximum = </span>
               <span className="qwerty-3">%d</span>
               <span className="qwerty-4">",</span>
               <span className="qwerty-5">a</span>
               <span className="qwerty-4">);</span>
           {"\n"}
                 <span className="qwerty-4" > &#125;</span>       
           {"\n"}
               <span className="qwerty-6"> else </span>
                           {"\n"}
               <span className="qwerty-4" > &#123; </span>
           {"\n"}       
           <span className="qwerty-8">  printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-10">maximum = </span>
               <span className="qwerty-3">%d</span>
               <span className="qwerty-4">",</span>
               <span className="qwerty-5">b</span>
               <span className="qwerty-4">);</span>
           {"\n"}
                 <span className="qwerty-4" > &#125;</span>       
        {"\n"}
        <span className="qwerty-4">&#125;</span>
        {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-2">main</span>
            <span className="qwerty-4"> ()</span>
        {"\n"}
            <span className="qwerty-4" >&#123; </span>
        {"\n"}
        <span className="qwerty-3">  int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">,</span>
            <span className="qwerty-5"> b</span>
            <span className="qwerty-4">;</span>
        {"\n"}
            <span className="qwerty-8"> printf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-10">Enter a no \n</span>
            <span className="qwerty-4">");</span>
        {"\n"}
          {"\n"}
            <span className="qwerty-6"> scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d %d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1">&amp;</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">,</span>
            <span className="qwerty-1">&amp;</span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-4">);</span>
        {"\n"}
          <span className="qwerty-2"> maximum</span>
            <span className="qwerty-4"> (</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">,</span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-4">);</span>
        {"\n"}
            <span className="qwerty-7"> return</span>
            <span className="qwerty-3"> 0</span>
            <span className="qwerty-4">; </span>
        {"\n"}
            <span className="qwerty-4">&#125;</span>
    </code>
    </pre>
    </div>          
    <h4 className='headings'>Output :</h4>
    <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
         <pre style={{maxHeight:"100vh"}}>
               <code >                  
               {"\n"}      
                 <span className="qwerty-8">Enter a no</span>                   
                 {"\n"}                           
                 <span className="qwerty-1"> 46</span>                   
                 {"\n"}                           
                 <span className="qwerty-1"> 58</span>                   
                 {"\n"}                           
                 <span className="qwerty-3">maximum =</span>                   
                 <span className="qwerty-1"> 58</span>                   
                 {"\n"}   {"\n"} 
                 </code>
                 </pre>
                 </div>  

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-user-defined-function"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cpassarg;